module.exports = __webpack_public_path__ + "img/青果.6e333cca.jpg";